import { render, staticRenderFns } from "./SalesForceSaleOrderView.vue?vue&type=template&id=32bb5b51&"
import script from "./SalesForceSaleOrderView.vue?vue&type=script&lang=js&"
export * from "./SalesForceSaleOrderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports